import { makeStyles } from '@mui/styles';

const commonFormWrap = {
  display: 'flex',
  margin: '0.8rem'
};

export const useStyles = makeStyles((theme) => ({
  personalInfoContainer: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  fullWidth: {
    width: '100%'
  },
  tooltipLabel: {
    display: 'flex',
    alignItems: 'center'
  },
  toolTipIcon: {
    color: '#6FADCC',
    width: 17,
    height: 17,
    marginLeft: '5px'
  },
  subTextColor: {
    color: theme.palette.primary.main
  },
  carrierAndPhContainer: commonFormWrap,
  carrierContainer: {
    marginRight: '1rem',
    minWidth: '50%',
  },
  policyGroupContainer: commonFormWrap,
  policyContainer: {
    marginRight: '1rem',
    minWidth: '50%'
  },
  patientRelDobContainer: commonFormWrap,
  patientRelContainer: {
    marginRight: '1rem',
    minWidth: '55%'
  },
  nameGenderContainer: commonFormWrap,
  nameContainer: {
    marginRight: '1rem',
    minWidth: '55%'
  },
  addrPhContainer: commonFormWrap,
  addrContainer: {
    marginRight: '1rem',
    minWidth: '55%'
  },
  formPageNumber: {
    fontSize: 16,
    textAlign: 'right',
    padding: '0.5rem 0.75rem 0 0',
    [theme.breakpoints.down(370)]: {
      fontSize: 12,
    }
  },
  contentTitleWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0.625rem 0 1rem 0',
  },
  contentTitleLine: {
    width: '100%',
    height: 0,
    border: '1px solid #567282',
    display: 'inline-block',
    background: '#567282'
  },
  titleLine1: {
    margin: '4px 10px 0 26px',
  },
  titleLine2: {
    margin: '4px 26px 0 10px',
  },
  contentTitle: {
    color: theme.palette.primary.dark,
    fontSize: 20,
    fontWeight: '500',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(370)]: {
      fontSize: 16,
    }
  },
  buttonsNavContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 1rem 1rem 1rem'
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 14,
    margin: '2px 0 0 4px',
  },
  btnDisabled: {
    background: theme.palette.common.grey,
    color: '#9e9e9e',
    '&:hover': {
      background: theme.palette.common.grey,
      color: '#9e9e9e',
    }
  },
  autoCompleteList: {
    '& div': {
      background: 'LightGray',
      lineHeight: '2',
      marginBottom: 2
    },
    '& ul': {
      margin: 0,
      paading: 0,
      '& li:nth-child(2n)': {
        background: '#efefef',
      },
      '& li:nth-child(2n+1)': {
        background: '#fff',
      },
      '& li': {
        listStyle: 'none',
        fontSize: 12,
        '&:hover': {
          background: '#E0E0E0',
        }
      }
    },
  },
  othersAutoCompleteOption: {
    cursor: 'pointer'
  },
}));
